'use es6';

import styled from 'styled-components';
export default styled('div').withConfig({
  displayName: "AvatarWrapper",
  componentId: "sc-1xetykp-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;transition-delay:150ms;transition:margin ease 300ms;flex-shrink:0;&:not(:only-of-type),& ~ &:not(:first-of-type){margin-", ":", "px;}&:last-of-type{", "}"], props => props._isListReversed ? 'left' : 'right', props => -1 * props.overlapOffset, props => props._isListReversed && 'margin-left: 0 !important;');